<template>
  <div>
    <el-dialog
      :title="isCreate ? '新增检测项' : '修改检测项'"
      center
      :visible="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :before-close="onClose"
      width="750px"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="250px"
        size="mini"
      >
        <el-form-item label="启用本配置：">
          <el-switch v-model="form.isCheck" active-color="#13ce66"> </el-switch>
        </el-form-item>
        <el-form-item label="ID：">
          <el-input
            :disabled="!isCreate"
            v-model.number="form.id"
            onkeyup="value=value.replace(/[^\d]/g, '')"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item label="付费金额不超过（元）：">
          <el-input
            v-model.number="form.minPaidYuan"
            onkeyup="value=value.replace(/[^\d]/g, '')"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item label="创角不超过（天）：">
          <el-input
            v-model.number="form.minPlayedDays"
            onkeyup="value=value.replace(/[^\d]/g, '')"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item label="道具ID：">
          <el-input
            v-model.number="form.itemId"
            onkeyup="value=value.replace(/[^\d]/g, '')"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item label="道具名称：">
          <el-input v-model="form.itemName" style="width: 250px"></el-input>
        </el-form-item>
        <el-form-item label="必须购买过的付费项：">
          <pay-point-selector
            placeholder="请选择"
            @ready="onPayPointSelectorReady"
            @change="onPayPointSelectorChange"
            ref="payPointSelector"
          >
          </pay-point-selector>
        </el-form-item>
        <el-form-item label="必须购买过包含该道具的任意付费项：">
          <el-switch v-model="form.fromPayProductReward" active-color="#13ce66">
          </el-switch>
        </el-form-item>
        <el-form-item label="在存档中的位置：">
          <el-input
            v-model="form.archiveLocation"
            style="width: 400px"
          ></el-input>
        </el-form-item>
        <el-form-item label="在存档中的数值类型：">
          <el-select
            v-model="form.valueType"
            placeholder="请选择"
            style="width: 130px"
          >
            <el-option
              v-for="item in valueTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="数值阈值：">
          <el-input v-model="form.maxNumber" style="width: 150px"></el-input>
        </el-form-item>

        <el-form-item label="拉进灰名单：">
          <el-switch v-model="form.isGreyList" active-color="#13ce66">
          </el-switch>
        </el-form-item>
        <el-form-item label="拉进黑名单：">
          <el-switch v-model="form.isBlackList" active-color="#13ce66">
          </el-switch>
        </el-form-item>

        <el-form-item label="备注：">
          <el-input v-model="form.remark" type="textarea" rows="3"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="submit()" style="margin-left: 30px"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");
import PayPointSelector from "@/components/PayPointSelector";

// 本弹窗名称
const DialogName = "EditDataMonitorDialog";

export default {
  data() {
    return {
      isCreate: false,
      form: {
        isCheck: true,
        valueType: "number",
      },
      valueTypeOptions: [
        {
          value: "object",
          label: "object",
        },
        {
          value: "number",
          label: "number",
        },
        {
          value: "time",
          label: "time",
        },
        {
          value: "boolean",
          label: "boolean",
        },
      ],
    };
  },
  components: { PayPointSelector },

  created() {
    let paramsFromOutside = dialogutil.getData(DialogName);

    if (!paramsFromOutside) {
      return;
    }

    this.isCreate = paramsFromOutside.isCreate;

    if (!paramsFromOutside.isCreate) {
      this.form = paramsFromOutside.entry;
    } else {
      // 创建或者复制
      if (paramsFromOutside.entry != null) {
        // 复制
        this.form = paramsFromOutside.entry;

        this.form.id = this.form.id + 1;
      }
    }

    if (this.form.mustBuyPayProduct == 0) {
      this.form.mustBuyPayProduct = "";
    }
  },

  methods: {
    /**
     * 提交表单
     */
    submit() {
      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },

    /**
     * 修改
     */
    async update() {
      try {
        // 弹确认框
        await this.$confirm(`确认修改检测项？`);
        if (this.form.mustBuyPayProduct == "") {
          this.form.mustBuyPayProduct = 0;
        }
        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/dataMonitor/update`,
            { entry: this.form },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onClose(null);
      } catch (e) {}
    },

    /**
     * 新增
     */
    async create() {
      try {
        // 弹确认框
        await this.$confirm(`确认新增检测项？`);

        if (this.form.mustBuyPayProduct == "") {
          this.form.mustBuyPayProduct = 0;
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/dataMonitor/add`,
            { entry: this.form },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "新增成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onClose(null);
      } catch (e) {}
    },

    async onPayPointSelectorReady() {
      this.$refs.payPointSelector.payPoint = this.form.mustBuyPayProduct;
    },

    async onPayPointSelectorChange(newValue, oldValue) {
      this.form.mustBuyPayProduct = newValue;
    },

    onClose(done) {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },
  },
};
</script>